import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import {
  changeShowChkAction,
  changewDataCatAction,
} from "../../redux/ui/actions";
import { DiscreteColorLegend } from "react-vis";

const waterData = [
  { value: "stream", text: "河川", id: 1, info: "出典：国土地理院" },
  { value: "coast", text: "海岸線", id: 2, info: "出典：国土地理院" },
  { value: "ws", text: "流域界", id: 3, info: "出典：国土地理院" },
  { value: "lake", text: "湖沼", id: 3, info: "出典：国土地理院" },
  { value: "score1", text: "最適透水係数（砂・礫・砂礫）", id: 4, info: "" },
  { value: "score2", text: "FEM自己なし(計算/計測)", id: 5, info: "" },
  { value: "aiscore", text: "AI自己あり", id: 6, info: "" },
  { value: "aiscore2", text: "AI自己なし", id: 7, info: "" },
  { value: "depth", text: "深度", id: 8, info: "" },
  { value: "pomp", text: "揚水量", id: 9, info: "" },
  { value: "kCont", text: "透水係数コンターXY", id: 9, info: "" },
  { value: "kCont2", text: "透水係数コンターXYVSR", id: 9, info: "" },
];

const mapStateToProps = (state) => {
  return {
    bmap: state.uiReducer.bmap,
    ds: state.uiReducer.ds,
    wDataCat: state.uiReducer.wDataCat,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.changeShowChk = this.changeShowChk.bind(this);
    this.state = {
      checkedItems: {}, // 各チェックボックスのチェック状態を管理するためのオブジェクト
    };
  }

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const { checkedItems } = this.state;

    // クリックされたチェックボックスの名前をキーとして、そのチェック状態を更新
    this.setState({
      checkedItems: {
        ...checkedItems,
        [name]: checked,
      },
    });

    // 他のチェックボックスのチェックを解除
    Object.keys(checkedItems).forEach((itemName) => {
      if (itemName !== name && checkedItems[itemName]) {
        if (itemName.indexOf("kCont") != -1) {
          return;
        }
        this.setState(
          (prevState) => ({
            checkedItems: {
              ...prevState.checkedItems,
              [itemName]: false,
            },
          }),
          () => {
            // チェックボックスの状態が変更された後に changeShowChk メソッドを呼び出す
            this.changeShowChk(itemName, false);
          }
        );
      }
    });

    // クリックされたチェックボックスの状態を更新
    this.setState(
      (prevState) => ({
        checkedItems: {
          ...prevState.checkedItems,
          [name]: checked,
        },
      }),
      () => {
        // チェックボックスの状態が変更された後に changeShowChk メソッドを呼び出す
        this.changeShowChk(name, checked);
      }
    );
  };
  /*
   * レイヤー表示変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeShowChk = (name, checked) => {
    window.changeShowData(name, checked);
    const val = name;
    this.props.ds[val] = checked;
    const ds = this.props.ds[val];
    this.props.dispatch(changeShowChkAction(val, ds));
    if (checked) {
      this.props.dispatch(changewDataCatAction(name));
    } else {
      this.props.dispatch(changewDataCatAction(null));
    }
  };

  render() {
    let items;
    const { checkedItems } = this.state;

    switch (this.props.wDataCat) {
      case "score1":
        items = [
          { title: "10以上[倍]", color: "#E60012" },
          { title: "7以上〜10未満[倍]", color: "#ef6600" },
          { title: "4以上〜7未満[倍]", color: "#fff100" },
          { title: "1以上〜4未満[倍]", color: "#00b248 " },
          { title: "0.7以上〜1未満[倍]", color: "#00e2d6 " },
          { title: "0.4以上〜0.7未満[倍]", color: "#00a4ff " },
          { title: "0.1以上〜0.4未満[倍]", color: "#005cff " },
          { title: "0.1未満[倍]", color: "#0016b7 " },
        ];
        break;
      case "score2":
        items = [
          { title: "1000以上[%]", color: "#85202A" },
          { title: "300以上〜1000未満[%]", color: "#E8727C" },
          { title: "100以上〜300未満[%]", color: "#F5DBDE" },
          { title: "30以上〜100未満[%]", color: "#CBEAF6 " },
          { title: "10以上〜30未満[%]", color: "#1e90ff " },
          { title: "10未満[%]", color: "#000080 " },
        ];
        break;
      case "aiscore":
      case "aiscore2":
        items = [
          { title: "95以上〜100以下[%]", color: "#006400 " },
          { title: "75以上〜95未満[%]", color: "#00ff00 " },
          { title: "50以上〜75未満[%]", color: "#8fbc8f " },
          { title: "25以上〜50未満[%]", color: "#f5deb3 " },
          { title: "0以上〜25未満[%]", color: "#ff8c00 " },
        ];
        break;
      case "pomp":
        items = [
          { title: "2000以上〜100以下[m3/d]", color: "#2b0e47" },
          { title: "1000以上〜2000未満[m3/d]", color: "#551d8d " },
          { title: "500以上〜1000未満[m3/d]", color: "#802bd5 " },
          { title: "100以上〜500未満[m3/d]", color: "#aa72e2" },
          { title: "0以上〜100未満[m3/d]", color: "#eadcf8" },
        ];
        break;
      case "depth":
        items = [
          { title: "200以上〜[m]", color: "#0a0a0a " },
          { title: "100以上〜200未満[m]", color: "#5f5f5f " },
          { title: "50以上〜100未満[m]", color: "#bfbfbf " },
          { title: "0以上〜50未満[m]", color: "#ffffff " },
        ];
        break;
      // 他のケース
      default:
        items = [];
    }
    return (
      <div className="TopBtnSwM">
        <ul>
          {waterData.map((el, index) => (
            <li
              className={index === 0 ? "l-right" : "l-right l-mtSS"}
              key={index}
            >
              <p className="l-left">
                <input
                  id={"bmap_" + el.value}
                  className="check"
                  value={index}
                  name={el.value}
                  type="checkbox"
                  onClick={this.handleCheckboxChange}
                  checked={checkedItems[el.value] || false} // チェック状態を反映する
                />
                <label htmlFor={"bmap_" + el.value}>{el.text}</label>
              </p>
              {/*
                            <button className='infoBtn l-blank' data-tip={el.info}>
                                <ReactTooltip effect='float' />
                           </button>
                            */}
            </li>
          ))}
        </ul>
        {(this.props.wDataCat === "score1" ||
          this.props.wDataCat === "score2" ||
          this.props.wDataCat === "aiscore" ||
          this.props.wDataCat === "aiscore2" ||
          this.props.wDataCat === "pomp" ||
          this.props.wDataCat === "depth") && (
          <fieldset className="Unit">
            <legend> 凡例</legend>
            <div className="legendSw">
              <DiscreteColorLegend
                orientation="horizontal"
                items={items}
                getSymbol={(d) => (
                  <svg width="10" height="10">
                    <circle cx="5" cy="5" r="4" fill={d.color} />
                  </svg>
                )}
              />
            </div>
          </fieldset>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
